"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("title", null, "Trace Icons_1-3"), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Artboard-32"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16,11.4a7.38,7.38,0,1,0,7.37,7.38A7.38,7.38,0,0,0,16,11.4Zm0,13.45a6.08,6.08,0,1,1,6.07-6.07A6.07,6.07,0,0,1,16,24.85Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M14.38,20.77l-1.9-1.9-.92.92,2,2a1.16,1.16,0,0,0,.85.35,1.2,1.2,0,0,0,.85-.35l5.21-5.21-.92-.92Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M27.46,8.77,21.18,2.54a.68.68,0,0,0-.46-.19H7.44a3.06,3.06,0,0,0-3.09,3V26.64a3.06,3.06,0,0,0,3.09,3H24.56a3.06,3.06,0,0,0,3.09-3V9.23A.66.66,0,0,0,27.46,8.77Zm-1.26.58H23a2.25,2.25,0,0,1-2.34-2.13V3.85Zm-1.64,19H7.44a1.76,1.76,0,0,1-1.79-1.71V5.36A1.76,1.76,0,0,1,7.44,3.65H19.35V7.22A3.54,3.54,0,0,0,23,10.65h3.36v16A1.75,1.75,0,0,1,24.56,28.35Z"
})));
module.exports = exports.default;